import React from 'react';
import { useSelector } from 'react-redux';
import { Avatar } from '@mui/material';

const Favicon = ({ company, size = 24 }) => {
  const analysisResults = useSelector((state) => state.competitorsReducer.competitorsAnalysisResults.analysis_results);

  // Find the matching company's favicon from analysis_results
  const favicon = analysisResults?.find((item) => {
    const companyDomain = company.toLowerCase().replace(/^https?:\/\//, '');
    const itemDomain = item.url.toLowerCase().replace(/^https?:\/\//, '');
    return itemDomain.includes(companyDomain) || companyDomain.includes(itemDomain);
  })?.favicon;

  return (
    <Avatar
      src={favicon}
      sx={{
        width: size,
        height: size,
        bgcolor: 'grey.100',
        color: 'text.secondary'
      }}
    >
      {company.charAt(0).toUpperCase()}
    </Avatar>
  );
};

export default Favicon;
